import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["type", "rewardGroup"];

  connect() {
    this.update();
  }

  update() {
    const type = this.typeTarget.value;
    this.rewardGroupTargets.forEach((group) => {
      const active = group.dataset.rewardType === type;
      group.classList.toggle("hidden", !active);
      group.querySelectorAll("input, select, textarea").forEach((field) => { field.disabled = !active; });
    });
  }
}
